/**
 * @generated SignedSource<<f5d177499e9125f18714981b94147fbe>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CompositionCategoryUpdateInput = {
  categoryID?: number | null;
  displayOrder?: number | null;
  macroCategoryId: number;
  name: string;
};
export type presetConfigurationsQueriesCreateCategoryMutation$variables = {
  input: CompositionCategoryUpdateInput;
};
export type presetConfigurationsQueriesCreateCategoryMutation$data = {
  readonly insertCompositionCategory: {
    readonly categoryID: number;
    readonly displayOrder: number;
    readonly id: string;
    readonly name: string | null;
  };
};
export type presetConfigurationsQueriesCreateCategoryMutation = {
  response: presetConfigurationsQueriesCreateCategoryMutation$data;
  variables: presetConfigurationsQueriesCreateCategoryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "compositionCategory",
        "variableName": "input"
      }
    ],
    "concreteType": "CompositionCategory",
    "kind": "LinkedField",
    "name": "insertCompositionCategory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "categoryID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayOrder",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "presetConfigurationsQueriesCreateCategoryMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "presetConfigurationsQueriesCreateCategoryMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "1c66707a427eb2ef99184125d0c62990",
    "id": null,
    "metadata": {},
    "name": "presetConfigurationsQueriesCreateCategoryMutation",
    "operationKind": "mutation",
    "text": "mutation presetConfigurationsQueriesCreateCategoryMutation(\n  $input: CompositionCategoryUpdateInput!\n) {\n  insertCompositionCategory(compositionCategory: $input) {\n    id\n    categoryID\n    name\n    displayOrder\n  }\n}\n"
  }
};
})();

(node as any).hash = "03c35adb22434a6ab38792122e0263c3";

export default node;
